<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 16 16"
       role="presentation"
       @click="$emit('click')">
    <path :fill="disabled ? disabledStateColor : iconColor" fill-rule="nonzero" d="M7.16 1.036c.676 1.193.703 2.63.266 4.916a.227.227 0 0 0 .21.258h6.008c.415.195.681.569.732 1.012.05.437-.12.935-.562 1.379h-3.15a.223.223 0 0 0-.217.217c0 .115.102.22.217.218h3.163c0 .025.005.05.014.074.195.587.07 1.371-.475 2.1h-2.702a.223.223 0 0 0-.217.217c0 .114.102.219.217.217h2.296c0 .025.005.05.013.075.195.586.072 1.37-.474 2.098h-1.835a.223.223 0 0 0-.217.218c0 .115.102.219.217.217h1.463c-.13.65-.363 1.119-1.104 1.739-4.12-.016-5.972.055-6.957-.048-.497-.051-.764-.138-1.043-.305-.27-.162-.566-.416-1.023-.781V7.9c2.086-2.756 2.989-2.486 3.096-5.317.08-.773 0-2.58 0-2.58.593-.057 1.85.548 2.064 1.032z"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
